"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var themes_1 = require("../../themes");
exports.default = (0, styles_1.makeStyles)(function () {
    return (0, styles_1.createStyles)({
        root: function (_a) {
            var displayNewLineBreaks = _a.displayNewLineBreaks, muted = _a.muted;
            return ({
                whiteSpace: displayNewLineBreaks ? 'pre-wrap' : undefined,
                color: muted ? themes_1.materialColors.grey[400] : undefined,
            });
        },
    });
});
